var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.4 2H5V2.8H4.2001V5.2L5 5.2V6H7.4V5.2L5.0001 5.2V2.8H7.4V2ZM7.4001 2.8H8.2001V5.2H7.4001V2.8ZM3 7.6H3.8V9.2H8.60007V7.6H9.40007V10H9.4H8.60007H3.8H3V9.2V7.6ZM3.8 7.6L8.6 7.6V6.8H3.8V7.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserS);
export default __webpack_public_path__ + "static/media/user-s.1b5a906c66f4ef45b77677b0123d4754.svg";
export { ForwardRef as ReactComponent };